<template>
    <li class="chat-list-group-item mt-3 px-4 py-2" @click="$emit('select', chat);" :class="[isSelected ? 'selected-chat-list-group-item' : '', chat.isNotification ? 'notification' : '', statusClass]">
        <div class="d-flex align-items-center chat-item-row gap-4 p-2">
            <div v-if="chat.unread" class="unread"></div>
            <div class="avatar-col">
                <div class="avatar">
                    <span v-if="!avatar[chat.participants[0].user.id]">{{ getInitials() }}</span>
                    <img v-else :src="avatar[chat.participants[0].user.id]" alt="avatar" class="avatar-img" height="40" width="40"/>
                </div>
            </div>
            <div class="details-col">
                <div>
                    <span class="user-name">{{ chat.participants[0].user.name }}</span>
                </div>
                <div class="item-info">
                    <small class="text-muted last-message">{{ preview }}</small>
                </div>
            </div>
            <div class="status-col d-flex flex-column" :class="statusClass">
                <small class="text-muted last-activity">{{ lastActivity }}</small>
                <span class="status-string">{{ this.getStatusString }}</span>
                <span v-if="chat.isNotification" class="tranferred-by">{{ chat.owner.name }}</span>
                <span v-else-if="holdingColleague" class="tranferred-by">{{ holdingColleague.name }}</span>
            </div>
        </div>
    </li>
</template>
<script>
    import avatarManager from '../../utils/avatarManager.js'
    import { colleagueHolding } from '../../utils/chatClaim.js'
    import { previewOf } from '../../utils/chatMessages.js'
    import moment from 'moment'

    function isUnclaimed(chat) {
        return !chat.owner;
    }

    function openStatusOf(chat, holdingColleague) {
        if (holdingColleague) {
            return { label: 'Picked up', className: 'status-picked-up' };
        }

        return isUnclaimed(chat)
            ? { label: 'Unclaimed', className: 'status-unclaimed' }
            : { label: 'Open', className: 'status-open' };
    }

    export default {
        name: 'ChatItem',
        data() {
            return {
                avatar: []
            }
        },
        props: {
            chat: {
                type: Object,
                required: true
            },
            isSelected: {
                type: Boolean,
                required: false
            }
        },
        computed: {
            preview() {
                return previewOf(this.chat.last_message, this.chat.is_workfix_line === true, this.lastSenderName);
            },
            lastSenderName() {
                const senderId = this.chat.last_message && this.chat.last_message.sender_id;
                const viewer = this.$store.getters.getHourAppUser;

                if (viewer && senderId === viewer.id) {
                    return 'You';
                }

                return this.chat.owner && this.chat.owner.id === senderId ? this.chat.owner.name : 'A colleague';
            },
            lastActivity() {
                const at = moment(this.chat.last_message ? this.chat.last_message.created_at : this.chat.created_at);

                return at.format(at.isSame(moment(), 'day') ? 'HH:mm' : 'DD/MM/YYYY');
            },
            getStatusString() {
                const status = this.chat.status.toLowerCase();
                const result = ({
                    'resolved': 'Archived',
                    'reallocating': 'Transfering',
                    'closing': 'Closing',
                })[status];
                if(!result) {
                    return openStatusOf(this.chat, this.holdingColleague).label
                }
                return result;
            },
            statusClass() {
                const status = this.chat.status.toLowerCase();
                const result = ({
                    'resolved': 'status-archived',
                    'reallocating': 'status-transfering',
                    'closing': 'status-closing',
                })[status];
                if(!result) {
                    return openStatusOf(this.chat, this.holdingColleague).className
                }
                return result;
            },
            holdingColleague() {
                return colleagueHolding(this.chat, this.$store.getters.getHourAppUser);
            }
        },
        methods: {
            getInitials() {
                const user = this.chat.participants[0].user;
                return avatarManager.getAvatar(user, (avatarUrl) => {
                    this.$set(this.avatar, user.id, avatarUrl);
                });
            }
        },
        created() {
            this.getInitials();
        }
    }
</script>
  
<style scoped>
    .chat-list-group-item {
        list-style: none;
        border-radius: 5px;
        cursor: pointer;
    }
    .selected-chat-list-group-item {
        background-color: #E7F1F1;
    }
    .avatar-col {
        flex: 0 0 50px;
        max-width: 50px;
    }
    .status-col {
        flex: 0 0 90px;
        min-width: 90px;
        text-align: right;
        font-size: 1.4rem;
        font-weight: 600;
    }
    .details-col {
        flex: 1 1 90px;
        min-width: 0;
        overflow: hidden;
        font-size: 1.25rem;
    }
    .chat-item-row {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
    }
    .avatar {
        width: 40px;
        height: 40px;
        border-radius: 5px;
        background-color: #146F70;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1.6rem;
    }
    .user-name {
        font-size: 1.4rem;
        font-weight: 600;
    }
    .item-info {
        display: flex;
        flex-direction: column;
    }
    .item-info .last-message {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: none;
    }
    .text-muted {
        font-size: 1.2rem;
        text-transform: capitalize;
    }
    .user-name {
        color: #282828;
    }
    .status-open .status-string {
        color: #D32F2F;
    }
    .status-archived .status-string {
        color: #2079D5;
    }
    .status-closing .status-string {
        color: #0059B5;
    }
    .status-transfering .status-string, .notification .user-name {
        color: #FF924E;
    }
    .status-unclaimed .status-string {
        color: #146F70;
    }
    .status-picked-up .status-string {
        color: #8d97ad;
    }
    li.status-unclaimed {
        border: 1px #146F70 dashed;
    }
    li.status-unclaimed:not(.selected-chat-list-group-item) {
        background-color: #F1F7F7;
    }
    .notification {
        border: 1px #FF924E solid;
        background-color: #FBF1EA;
    }
    .tranferred-by {
        font-size: 1rem;
        font-weight: 400;
    }
    .unread {
        position: absolute;
        right: 3px;
        top: 12px;
        background: orange;
        border-radius: 20px;
        width: 10px;
        height: 10px;
    }
    @media (max-width: 1590px) and  (min-width:770px) {
        .details-col {
            flex: 0 0 100%;
            max-width: 100%;
            margin-top: 0.5rem;
            text-align: left;
        }
        .status-col {
            flex: 0 0 100% !important;
            max-width: 100% !important;
            width: 100% !important;
            margin: 0.5rem 0 0;
            text-align: center;
        }
    }
</style>
  